(() => {
  function initializeDescriptions(root = document) {
    root.querySelectorAll('.collection-hero__description').forEach((description) => {
      const more = description.querySelector('.read-more');
      const less = description.querySelector('.read-less');
      const content = description.querySelector('.accordion-content');
      if (!more || !less || !content || description.dataset.descriptionReady) return;
      description.dataset.descriptionReady = 'true';
      more.addEventListener('click', (event) => {
        event.preventDefault();
        content.style.display = 'block';
        more.style.display = 'none';
      });
      less.addEventListener('click', (event) => {
        event.preventDefault();
        content.style.display = 'none';
        more.style.display = 'inline';
        more.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDescriptions(), { once: true });
  } else {
    initializeDescriptions();
  }
  document.addEventListener('shopify:section:load', (event) => initializeDescriptions(event.target));
})();
